import { render, staticRenderFns } from "./CandidateJobsExpandableView.vue?vue&type=template&id=2cf2495c"
import script from "./CandidateJobsExpandableView.vue?vue&type=script&lang=js"
export * from "./CandidateJobsExpandableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports